
import { notification } from 'ant-design-vue';

export function successNotification(title, desc) {
    notification.success({
        message: title,
        description: desc,
    });
}

export function errorNotification(title, desc) {
    notification.error({
        message: title,
        description: desc,
    });
}

export function infoNotification(title, desc) {
    notification.info({
        message: title,
        description: desc,
    });
}

export function warningNotification(title, desc) {
    notification.warning({
        message: title,
        description: desc,
    });
}

export function warnNotification(title, desc) {
    notification.warn({
        message: title,
        description: desc,
    });
}